module.exports = __webpack_public_path__ + "img/21.fcbc7440.jpg";